import { mapGetters } from "vuex";
import { formatPrice } from "@/helpers";

export default {
  name: "sales-Invoice",
  data() {
    return {
      isOpen: false,
      showDisplacement: "",
    };
  },
  props: {
    type: {
      type: String,
    },
    displacement: {
      type: Object,
      default: () => {},
    },
    showElement: {
      type: Boolean,
      default: true,
    },
    document: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters({
      isManager: "profile/isManager",
    }),
  },
  methods: {
    formatPrice,
    openDisplacement(item) {
      this.$emit("open-displacement", item);
      this.isOpen = true;
    },
  },
};
